export default __webpack_public_path__ + "static/media/sherlock.8b6c4dfe.png";